module.exports = __webpack_public_path__ + "fonts/icomoon.07a3d94.woff";